import { AxiosResponse } from 'axios';
import { useAxios } from '../../composables/axios';
import { Support } from './support.model';

const axios = useAxios();

export interface SupportService {
  Fetch: () => Promise<AxiosResponse<Support[]>>;
}

const Fetch = (): Promise<AxiosResponse<Support[]>> =>
  axios.Get<Support[]>('api/supports');

export default { Fetch } as SupportService;
